import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const Mileage = (props) => {


  return (
    <Row className="justify-content-md-center">
      <Col xs={12}>
        <Form>
          <Form.Group>
            <Form.Label><i className="fa fa-car"></i> Sisestage sõiduki läbisõit</Form.Label>

            <Row className="mt-2">
              <Col xs={12} md={6} className="mb-2 mb-md-0 offset-md-3">
                <Form.Control 
                  className={
                    props.isValid!==null ?
                      props.isValid===true? "is-valid" : "is-invalid"
                    : null
                  }
                  placeholder="Läbisõit (km)"
                  onChange={props.changed}
                  value={props.value}
                  name="trumpauto-car-mileage"
                  />

              </Col>
            </Row>
          </Form.Group>

        </Form>
      </Col>
    </Row>
  )

}

export default Mileage;